<template>
  <!-- 管理员-医疗机关查看列表-编辑-->
  <div class="main-css">
    <!--    标题-->
    <div class="title-css">{{ $t("medicalInstitutionManagement") }}</div>
    <div class="main-box">
      <!-- button 部分 -->
      <div class="line-button-box">
        <el-button class="button-css" @click="handleAddClick">{{
          $t("new")
        }}</el-button>
        <el-dropdown @command="alterMedicalStatu">
          <el-button type="primary" class="button-css">
            {{ $t("stateChange") }}
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item1, index) in statusData"
              :key="item1.code"
              :command="item1"
              >{{ item1.name }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <el-button class="button-css" @click="handleDeleteClick">{{
          $t("delete")
        }}</el-button>
      </div>
      <!-- table部分 -->
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          style="width: 95%"
          height="520"
          @row-click="rowClick"
          @cell-click="tableCellClick"
          :cell-class-name="
            ({ row, column, rowIndex, columnIndex }) => (
              (row.index = rowIndex), (column.index = columnIndex)
            )
          "
          @selection-change="handleSelectionChange"
          @sort-change="changeTableSort"
          v-loading="loading"
          empty-text=" "
        >
          <el-table-column type="selection" width="45"> </el-table-column>
          <!-- ----------------------機関番号---------------------- -->
          <el-table-column
            prop="medicalId"
            label="機関番号"
            width="130"
            fixed="left"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("medicId") }}</p>
              <el-input
                v-model="searchData1"
                placeholder="Search"
                @input="inputSearch"
                size="mini"
              />
            </template>
          </el-table-column>
          <!--          &lt;!&ndash; &#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;写真&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45; &ndash;&gt;-->
          <!--          <el-table-column label="写真"  width="80" fixed="left">-->
          <!--            <template slot="header" >-->
          <!--              <p>{{ $t("photograph") }}</p>-->
          <!--              <el-input-->
          <!--                size="mini"-->
          <!--                placeholder="Search"-->
          <!--              />-->
          <!--            </template>-->
          <!--            <template slot-scope="scope">-->
          <!--              <img src="./assets/User.png" alt="" class="table-img-css"/>&lt;!&ndash; 头像地址：avatarAddress &ndash;&gt;-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <!-- ----------------------医疗機関名---------------------- -->
          <el-table-column
            prop="medicalName"
            label="医疗機関名"
            width="200"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("medicalInstitution") }}</p>
              <el-input
                placeholder="Search"
                v-model="searchData2"
                @input="inputSearch"
                size="mini"
              />
            </template>
          </el-table-column>
          <!-- ---------------------機関属性medicalAttributes-------------------- -->
          <el-table-column
            prop="attributes"
            label="機関属性"
            min-width="200"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("institutionalAttributes") }}</p>
              <el-dropdown @command="handleCommandmedicalAttributes">
                <span class="el-dropdown-link">
                  {{ medicalAttributesName
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in medicalAttributesData"
                    :key="item.code"
                    :command="item"
                    >{{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.attributes_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpattributes_dictText }}
              </span>
            </template>
          </el-table-column>

          <!-- ----------------------郵便番号---------------------- -->
          <el-table-column
            prop="postNumber"
            label="郵便番号"
            width="100"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("postCode") }}</p>
              <el-input
                placeholder="Search"
                v-model="searchData3"
                @input="inputSearch"
                size="mini"
                clearable
              />
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.postNumber"
                  size="mini"
                  @blur="tableCellInputBlur"
                  autofocus
                />
              </span>
              <span v-else>{{ scope.row.postNumber }}</span>
            </template>
          </el-table-column>

          <!-- ----------------------所在地---------------------- -->
          <el-table-column
            prop="address"
            label="所在地"
            width="200"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("location") }}</p>
              <el-input
                placeholder="Search"
                v-model="searchData4"
                size="mini"
              />
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.address"
                  size="mini"
                  @blur="tableCellInputBlur"
                  autofocus
                />
              </span>
              <span v-else>{{ scope.row.address }}</span>
            </template>
          </el-table-column>
          <!-- ----------------------代表者---------------------- -->
          <el-table-column
            prop="legalPerson"
            label="代表者"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("representativeName") }}</p>
              <el-input
                placeholder="Search"
                v-model="searchData5"
                @input="inputSearch"
                size="mini"
              />
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.legalPerson"
                  size="mini"
                  @blur="tableCellInputBlur"
                  autofocus
                />
              </span>
              <span v-else>{{ scope.row.legalPerson }}</span>
            </template>
          </el-table-column>
          <!-- ----------------------電話番号---------------------- -->
          <el-table-column
            prop="telephone"
            label="電話番号"
            width="150"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("telephoneNumber") }}</p>
              <el-input
                placeholder="Search"
                v-model="searchData6"
                @input="inputSearch"
                size="mini"
              />
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.telephone"
                  size="mini"
                  @blur="tableCellInputBlur"
                  autofocus
                />
              </span>
              <span v-else>{{ scope.row.telephone }}</span>
            </template>
          </el-table-column>
          <!-- -----------------------授業員数----------------------- -->
          <el-table-column
            prop="employeeNumber"
            label="授業員数"
            width="140"
            sortable
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("numberOfEmployees") }}</p>
              <el-dropdown @command="handleCommandemployeeNumber">
                <span class="el-dropdown-link">
                  {{ employeeNumberName
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in employeeNumberData"
                    :key="item.code"
                    :command="item"
                    >{{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.employeeNumber"
                  size="mini"
                  @blur="tableCellInputBlur"
                  autofocus
                />
              </span>
              <span v-else
                ><span v-if="language === 'CN'">
                  {{ scope.row.employeeNumber_dictText }}
                </span>
                <span v-else>
                  {{ scope.row.jpemployeeNumber_dictText }}
                </span></span
              >
            </template>
          </el-table-column>
          <!-- -----------------------床位数----------------------- -->
          <el-table-column prop="bedNumber" label="床位数" width="140" sortable>
            <template slot="header" slot-scope="scope">
              <p>{{ $t("bedNumber") }}</p>
              <el-dropdown @command="handleCommandbedNumber">
                <span class="el-dropdown-link">
                  {{ bedNumberName
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in bedNumberData"
                    :key="item.code"
                    :command="item"
                    >{{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.bedNumber"
                  size="mini"
                  @blur="tableCellInputBlur"
                  autofocus
                />
              </span>
              <span v-else>
                <span v-if="language === 'CN'">
                  {{ scope.row.bedNumber_dictText }}
                </span>
                <span v-else>
                  {{ scope.row.jpbedNumber_dictText }}
                </span></span
              >
            </template>
          </el-table-column>
          <!-- -----------------------资本数----------------------- -->
          <el-table-column
            prop="capitalAmount"
            label="资本金"
            width="140"
            sortable
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("capital") }}</p>
            </template>
            <!-- <template slot="header" slot-scope="scope">
              <p>{{ $t("capital") }}</p>
              <el-dropdown @command="handleCommandbedNumber">
                <span class="el-dropdown-link">
                  {{ bedNumberName
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in bedNumberData"
                    :key="item.code"
                    :command="item"
                    >{{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template> -->
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.capitalAmount2"
                  size="mini"
                  @blur="tableCellInputBlur"
                  autofocus
                />
              </span>
              <span v-else>
                <span v-if="language === 'CN'">
                  {{ scope.row.capitalAmount_dictText }}
                </span>
                <span v-else>
                  {{ scope.row.jpcapitalAmount_dictText }}
                </span>
              </span>
            </template>
          </el-table-column>
          <!-- ----------------------HP SNS---------------------- -->
          <el-table-column
            prop="hpOrSns"
            label="HP SNS"
            width="170"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("hpOrSns") }}</p>
              <el-input
                placeholder="Search"
                v-model="searchData1"
                @input="inputSearch"
                size="mini"
              />
            </template>
            <template slot-scope="scope">
              <span
                v-if="
                  scope.row.index === tableCellClickRowIndex &&
                    scope.column.index === tableCellClickColumnIndex
                "
              >
                <el-input
                  placeholder="请输入内容…"
                  v-model="scope.row.hpOrSns"
                  size="mini"
                  @blur="tableCellInputBlur"
                  autofocus
                />
              </span>
              <span v-else>{{ scope.row.hpOrSns }}</span>
            </template>
          </el-table-column>
          <!--          &lt;!&ndash; -&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;求人案件数-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45; &ndash;&gt;-->
          <!--          <el-table-column-->
          <!--            prop="casesNumber"-->
          <!--            label="求人案件数"-->
          <!--            width="150"-->
          <!--            sortable-->
          <!--          >-->
          <!--            <template slot="header" slot-scope="scope">-->
          <!--              <p>{{ $t("jobCaseNumber") }}</p>-->
          <!--&lt;!&ndash;              <el-dropdown>&ndash;&gt;-->
          <!--&lt;!&ndash;                <span class="el-dropdown-link">&ndash;&gt;-->
          <!--&lt;!&ndash;                  All<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>&ndash;&gt;-->
          <!--&lt;!&ndash;                </span>&ndash;&gt;-->
          <!--&lt;!&ndash;                <el-dropdown-menu&ndash;&gt;-->
          <!--&lt;!&ndash;                  slot="dropdown" >&ndash;&gt;-->
          <!--&lt;!&ndash;                  <el-dropdown-item command="0">All</el-dropdown-item>&ndash;&gt;-->
          <!--&lt;!&ndash;                  <el-dropdown-item command="1">....</el-dropdown-item>&ndash;&gt;-->
          <!--&lt;!&ndash;                </el-dropdown-menu>&ndash;&gt;-->
          <!--&lt;!&ndash;              </el-dropdown>&ndash;&gt;-->
          <!--            </template>-->
          <!--          </el-table-column>-->

          <!-- -----------------------求人案件数----------------------- -->
          <el-table-column
            prop="casesNumber"
            label="求人案件数"
            width="150"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("jobCaseNumber") }}</p>
            </template>
          </el-table-column>

          <!-- -----------------------機関スタッフ  认证状态----------------------- -->

          <!--          <el-table-column-->
          <!--            prop="certifiyStatus"-->
          <!--            label="機関スタッフ"-->
          <!--            width="160"-->
          <!--            sortable-->
          <!--          >-->
          <el-table-column
            prop="certifiyStatus"
            label="機関スタッフ"
            width="160"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("certificationStatus") }}</p>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.certifiyStatus_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpcertifiyStatus_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-- -----------------------登録日付----------------------- -->
          <el-table-column
            prop="createTime"
            label="登録日付"
            width="140"
            sortable
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("registerDay") }}</p>
            </template>
            <template slot-scope="scope">
              <span>
                {{ scope.row.createTime.substring(0, 10) }}
              </span>
            </template>
          </el-table-column>
          <!-- -----------------------最新修正日付----------------------- -->
          <el-table-column
            prop="updateTime"
            label="最新修正日付"
            width="170"
            :show-overflow-tooltip="true"
            sortable
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("lastUpdataDay") }}</p>
            </template>
            <template slot-scope="scope">
              <span>
                {{ scope.row.updateTime.substring(0, 10) }}
              </span>
            </template>
          </el-table-column>
          <!-- -----------------------ID創設者----------------------- -->
          <el-table-column
            prop="userId"
            label="ID創設者"
            width="140"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("idCreater") }}</p>
            </template>
          </el-table-column>
          <!-- -----------------------観覧数----------------------- -->
          <el-table-column
            prop="browseNumber"
            label="観覧数"
            width="140"
            sortable
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("numberOfVisits") }}</p>
            </template>
          </el-table-column>
          <!-- -----------------------状態----------------------- -->
          <el-table-column prop="status" label="状態" width="160">
            <template slot="header" slot-scope="scope">
              <p>{{ $t("status") }}</p>
              <el-dropdown @command="handleCommandmedicalStatus">
                <span class="el-dropdown-link">
                  {{ medicalStatusName
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in medicalStatusData"
                    :key="item.code"
                    :command="item"
                    >{{ item.name }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.status_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jpstatus_dictText }}
              </span>
            </template>
          </el-table-column>
          <!-- ----------------------操作---------------------- -->
          <el-table-column
            fixed="right"
            label="操作"
            width="170"
            header-align="center"
          >
            <template slot-scope="scope">
              <el-button type="text" size="mini" v-if="scope.row.status == '1'">
                <button
                  class="save-button"
                  @click="alterMedicalStatuOk(scope.row)"
                >
                  {{ $t("yes") }}
                </button>
                <button
                  class="save-button"
                  @click="alterMedicalStatuNo(scope.row)"
                >
                  {{ $t("no") }}
                </button>
              </el-button>
              <el-button v-else type="text" size="mini">
                <button class="save-button" @click="handleSaveClick(scope.row)">
                  {{ $t("save") }}
                </button>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页部分 -->
      <div class="pagination">
        <div class="pagination-main">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            layout=" prev, pager, next"
            :total="totalNum"
            :page-size="pageSize"
          >
          </el-pagination>
          <!-- Rows per page -->
          <div class="rowsPage">
            <span>Rows per page</span>
            <div class="rowsPage-css">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ pageSize
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">7</el-dropdown-item>
                  <el-dropdown-item command="b">15</el-dropdown-item>
                  <el-dropdown-item command="c">20</el-dropdown-item>
                  <el-dropdown-item command="d">25</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  deleteMedicalInstitution,
  updateMedicalInstitutionOpenStatus, //修改医疗机构开放状态
  queryMedicalInstitutionDetailInfo,
  queryMedicalInstitutionStatus,
  fuzzyQueryMedicalInstitutionInfo,
  queryMedicalInstitutionInfo,
  updateMedicalInstitutionStatus,
  educationAuditUpdate,
  updateMedicalInstitutionInfo,
  updateAdminInfoAdmin
} from "../../js/api";
import AES from "../../js/AES";
import axios from "axios";
export default {
  name: "medicalStaffManagement",
  components: {},
  data() {
    return {
      tableData: [],
      idList: [],
      statusData: [],
      searchData1: "", //表格第一个搜索
      searchData2: "", //表格第二个搜索H220763
      searchData3: "", //表格第三个搜索
      searchData4: "", //表格第四个搜索
      searchData5: "",
      searchData6: "",
      searchData7: "",
      searchData8: "",
      searchData9: "",
      currentPage: 1, //页数
      pageSize: 7, //每页条数
      loading: false, //table loading
      searchDataStart: "",
      totalNum: 0,
      EducationStatus: "",
      language: "",
      medicalAttributes: "",
      medicalAttributesName: "All",
      medicalAttributesCode: "",
      medicalAttributesData: [],
      employeeNumber: "",
      employeeNumberName: "All",
      employeeNumberCode: "",
      employeeNumberData: [],
      bedNumber: "",
      bedNumberName: "All",
      bedNumberCode: "",
      bedNumberData: [],
      medicalStatus: "",
      medicalStatusName: "All",
      medicalStatusCode: "",
      medicalStatusData: [],
      tableCellClickRowIndex: null, // 点击的单元格行索引
      tableCellClickColumnIndex: null // 点击的单元格列索引
    };
  },
  created() {
    //获取当前语言的值
    this.language = window.localStorage.getItem("language");
    console.log("语言选择为" + window.localStorage.getItem("language"));
    console.log("页面语言选择为" + this.language);
    this.getLanguage();

    this.searchDataStart = this.$route.query.searchData;
    console.log(this.searchDataStart);
    this.gettingData();
    this.getReviewStatus();
    this.getmedicalAttributes();
    this.getemployeeNumber();
    this.getbedNumber();
    this.getmedicalStatus();
  },
  computed: {},
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
  },
  methods: {
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key == "language" && e.newValue) {
        that.language = e.newValue;
        this.gettingData();
        this.getReviewStatus();
        this.getmedicalAttributes();
        this.getemployeeNumber();
        this.getbedNumber();
        this.getmedicalStatus();
      }
    },
    //获得语言
    getLanguage() {
      if (this.language === "CN") {
        this.EducationStatus = "medStatusChange";
        this.medicalAttributes = "medicalAttributes";
        this.employeeNumber = "employeeNumber";
        this.bedNumber = "bedNumber";
        this.medicalStatus = "medicalStatus";
      } else {
        this.EducationStatus = "jpmedStatusChange";
        this.medicalAttributes = "jpmedicalAttributes";
        this.employeeNumber = "jpemployeeNumber";
        this.bedNumber = "jpbedNumber";
        this.medicalStatus = "jpmedicalStatus";
      }
    },
    //获取数据
    gettingData() {
      this.postCode = this.$route.query.id;
      this.getList();
    },
    //单元格获取焦点
    tableCellClick(row, column, cell, event) {
      this.tableCellClickRowIndex = row.index;
      this.tableCellClickColumnIndex = column.index;
    },
    // 单元格失去焦点
    tableCellInputBlur(row, event, column) {
      this.tableCellClickRowIndex = null;
      this.tableCellClickColumnIndex = null;
    },

    //接口 获取表格数据
    getList() {
      var fakeInfo = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      queryMedicalInstitutionInfo(fakeInfo)
        .then(res => {
          console.log("--------管理员查询医疗机构信息--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.totalNum = aesFecInfo.total;
            this.tableData = aesFecInfo.data;
          } else {
            this.$message.error("查询失败。");
          }
        })
        .catch(res => {});
    },

    // 医疗机构模糊查询 list
    inputSearch() {
      // 医疗机构模糊查询 list
      const fakeInfo = {
        address: this.searchData4,
        attributes: this.attributes,
        bedNumber: this.bedNumberCode,
        browseNumber: 0,
        capitalAmount: 0,
        casesNumber: 0,
        createTimeIn: "",
        createTimeOut: "",
        employeeNumber: this.employeeNumberCode,
        hpOrSns: "",
        legalPerson: this.searchData5,
        medicalId: this.searchData1,
        medicalName: this.searchData2,
        pageNumber: 1,
        pageSize: 15,
        postNumber: this.searchData3,
        status: 0,
        telephone: this.searchData6,
        updateTimeIn: "",
        updateTimeOut: "",
        userName: ""
      };
      fuzzyQueryMedicalInstitutionInfo(fakeInfo)
        .then(res => {
          console.log("----医疗机构模糊查询列表信息----");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.tableData = aesFecInfo.data;
          }
        })
        .catch(res => {
          console.log("----医疗机构模糊查询列表信息----");
          console.log(res);
        });
    },

    //获取状态数据字典
    getReviewStatus() {
      var that = this;
      that.getLanguage();
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: that.EducationStatus
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据review_status--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            // for (var i = 1; i < aesFecInfo.data.length; i++) {
            //   that.statusData[i - 1] = aesFecInfo.data[i];
            // }
            //修复少一个数据字典值bug
            that.statusData = aesFecInfo.data;

            console.log("--------获当然是看获取的状态了--------");

            console.log(that.statusData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },

    //行点击
    rowClick(row, column, cell, event) {
      console.log(row);
      console.log("行点击事件");
      if (column.label == "機関番号" || column.label == "医疗機関名") {
        this.$router.push({
          path: "/administratorsViewMedicalInstitutionsClickDetails",
          query: {
            medicalId: row.medicalId,
            userId: row.userId
          }
        });
      }
    },
    //table排序
    changeTableSort(column) {
      console.log(column);
      if (column.prop === "numberFacultyMembers") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["numberFacultyMembers"] - b["numberFacultyMembers"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["numberFacultyMembers"] - a["numberFacultyMembers"]
          );
        }
      } else if (column.prop === "numberStudent") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["numberStudent"] - b["numberStudent"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["numberStudent"] - a["numberStudent"]
          );
        }
      } else if (column.prop === "numberBeggingCase") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["numberBeggingCase"] - b["numberBeggingCase"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["numberBeggingCase"] - a["numberBeggingCase"]
          );
        }
      } else if (column.prop === "institutionalStaff") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["institutionalStaff"] - b["institutionalStaff"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["institutionalStaff"] - a["institutionalStaff"]
          );
        }
      } else if (column.prop === "payByDay") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["payByDay"] - b["payByDay"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["payByDay"] - a["payByDay"]
          );
        }
      } else if (column.prop === "latestRevisedDailyPayment") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) =>
              a["latestRevisedDailyPayment"] - b["latestRevisedDailyPayment"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) =>
              b["latestRevisedDailyPayment"] - a["latestRevisedDailyPayment"]
          );
        }
      } else if (column.prop === "NumberSecrets") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["NumberSecrets"] - b["NumberSecrets"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["NumberSecrets"] - a["NumberSecrets"]
          );
        }
      }
    },
    //页码变化
    handleCurrentChange(evt) {
      this.currentPage = evt;
      this.getList();
      console.log(this.currentPage);
    },

    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
        console.log(this.pageSize);
      } else if (command === "b") {
        this.pageSize = 15;
        console.log(this.pageSize);
      } else if (command === "c") {
        this.pageSize = 20;
        console.log(this.pageSize);
      } else if (command === "d") {
        this.pageSize = 25;
        console.log(this.pageSize);
      }
      this.currentPage = 1;
      this.getList();
    },

    //选择行数据
    handleSelectionChange(val) {
      console.log(val);
      this.idList = [];
      for (var i = 0; i < val.length; i++) {
        this.idList.push(val[i].medicalId);
      }
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },

    //机关属性筛选方法
    organAttributeClick(evt) {
      console.log(evt);
      if (evt === "0") {
        //全部
        console.log("全部");
      }
    },
    //修改医疗机构开放状态
    alterMedicalStatu(evt) {
      if (!this.idList[0]) {
        this.$message({
          message: this.$t("chooseRow"),
          type: "error"
        });
        return;
      }
      var fakeInfo = {
        medicalId: this.idList[0],
        status: evt.code
      };
      console.log(fakeInfo);
      updateMedicalInstitutionOpenStatus(fakeInfo)
        .then(res => {
          console.log("----修改医疗机构状态前接口----");
          console.log(res);
          console.log(fakeInfo);
          if (res.data.code === "A0000") {
            this.$message({
              message: this.$t("changeStatus"),
              type: "success"
            });
            this.gettingData();
          }
        })
        .catch(res => {
          console.log("----修改医疗机构状态接口失败----");
          console.log(res);
        });
    },

    //修改医疗机构开放状态ok
    alterMedicalStatuOk(row) {
      var fakeInfo = {
        medicalId: row.medicalId,
        status: 3
      };

      updateMedicalInstitutionOpenStatus(fakeInfo)
        .then(res => {
          console.log("----修改医疗机构状态ok接口----");
          console.log(res);
          console.log(fakeInfo);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.$message({
              
              message: this.$t("successfullyModified"),
              type: "success"
            });
            this.gettingData();
          }
        })
        .catch(res => {
          console.log("----修改医疗机构状态接口失败----");
          console.log(res);
        });
    },

    //修改医疗机构开放状态no
    alterMedicalStatuNo(row) {
      var fakeInfo = {
        medicalId: row.medicalId,
        status: 2
      };
      updateMedicalInstitutionOpenStatus(fakeInfo)
        .then(res => {
          console.log("----修改医疗机构状态no接口----");
          console.log(res);
          console.log(fakeInfo);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            this.$message({
              // message: '案件通过审核成功!',
              message: this.$t("successfullyModified"),
              type: "success"
            });
            this.gettingData();
          }
        })
        .catch(res => {
          console.log("----修改医疗机构状态接口失败----");
          console.log(res);
        });
    },
    //添加医疗机构
    handleAddClick() {
      this.$router.push("/administratorAddsMedicalInformation");
    },
    //删除指定医疗机构接口
    handleDeleteClick() {
      if (!this.idList[0]) {
        this.$message({
          message: this.$t("chooseRow"),
          type: "error"
        });
        return;
      }
      var medicalInstitutionDeleteDTO = {
        listId: this.idList
      };
      deleteMedicalInstitution(medicalInstitutionDeleteDTO)
        .then(res => {
          console.log("--------删除指定医疗机构接口数据--------");
          console.log(res);
          this.$message({
            message: this.$t("successfullyDeleted"),
            type: "success"
          });
          this.gettingData();
        })
        .catch(res => {
          console.log("删除指定医疗机构接口数据异常:", res);
        });
    },
    // 修改判断
    handleSaveClick(row) {
      const {
        address,
        attributes,
        avatarAddress,
        bedNumber,
        capitalAmount,
        certifiyStatus,
        employeeNumber,
        hpOrSns,
        legalPerson,
        medicalId,
        medicalName,
        postNumber,
        status,
        telephone,
        updateTime,
        userId,
        userName
      } = row;
      // "": ""
      console.log("保存button");
      // if (
      //   !row.postNumber &&
      //   !row.address &&
      //   !row.legalPerson &&
      //   !row.telephone &&
      //   !row.employeeNumber &&
      //   !row.bedNumber &&
      //   !row.hpOrSns
      // ) {

      //   return;
      // }
      // this.$message({
      //   message: this.$t("informationNotModified"),
      //   type: "warning"
      // });
      this.upDateInfo({
        address,
        attributes,
        avatarAddress,
        bedNumber,
        capitalAmount,
        certifiyStatus,
        employeeNumber,
        hpOrSns,
        legalPerson,
        medicalId,
        medicalName,
        postNumber,
        status,
        telephone,
        updateTime,
        userId,
        userName
      });
    },

    // 修改
    upDateInfo(row) {
      var fakeInfo = row;
      console.log(fakeInfo);
      updateMedicalInstitutionInfo(fakeInfo)
        .then(res => {
          console.log("-----修改信息接口-----");
          console.log(res);
          if (res.data.code === "A0160") {
            console.log(1);
            this.$message({
              message: this.$t("emailRegistered"),
              type: "warning"
            });
          } else if (res.data.code === "A0000") {
            // this.allAdminInfo();
            this.getList();
            this.$message({
              message: this.$t("successfullyModified"),
              type: "success"
            });
          } else {
            this.$message.error(this.$t("failToEdit"));
          }
        })
        .catch(res => {});
    },

    //获取medicalAttributes下拉
    handleCommandmedicalAttributes(evt) {
      this.attributes = evt.code;
      this.medicalAttributesName = evt.name;
      this.inputSearch();
    },
    //获取employeeNumber下拉
    handleCommandemployeeNumber(evt) {
      this.employeeNumberCode = evt.code;
      this.employeeNumberName = evt.name;
      this.inputSearch();
    },
    //获取bedNumber下拉
    handleCommandbedNumber(evt) {
      this.bedNumberCode = evt.code;
      this.bedNumberName = evt.name;
      this.inputSearch();
    },
    //获取medicalStatus下拉
    handleCommandmedicalStatus(evt) {
      this.medicalStatusCode = evt.code;
      this.medicalStatusName = evt.name;
    },
    getmedicalStatus() {
      var that = this;
      that.getLanguage();
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: that.medicalStatus
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据medicalStatus--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.medicalStatusData = aesFecInfo.data;
            console.log("--------获当然是看获取的状态了--------");
            console.log(that.medicalStatusData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },

    getemployeeNumber() {
      var that = this;
      that.getLanguage();
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: that.employeeNumber
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据employeeNumber--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.employeeNumberData = aesFecInfo.data;
            console.log("--------获当然是看获取的状态了--------");
            console.log(that.employeeNumberData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    getbedNumber() {
      var that = this;
      that.getLanguage();
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: that.bedNumber
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据bedNumber--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.bedNumberData = aesFecInfo.data;
            console.log("--------获当然是看获取的状态了--------");
            console.log(that.bedNumberData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    getmedicalAttributes() {
      var that = this;
      that.getLanguage();
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: that.medicalAttributes
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          that.medicalAttributesData = [];
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log(
              "--------获取数据字典接口数据medicalAttributes--------"
            );
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.medicalAttributesData = aesFecInfo.data;
            that.medicalAttributesData.push({
              code: "",
              dictCode: "medicalAttributes",
              name: that.$t("allName")
            });
            console.log("--------获当然是看获取的状态了1155--------");
            console.log(that.medicalAttributesData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    }
  }
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  position: relative;
}
.main-box {
  margin-top: 0px;
  width: 100%;
  padding: 0 40px 0 80px;
  box-sizing: border-box;
}
.title-css {
  /*标题样式*/
  font-family: "lucida sans unicode", "lucida grande", sans-serif; /*字体*/
  color: #686868; /*字体颜色*/
  font-size: 2em; /*字体大小*/
  text-align: center; /*对齐方式*/
  line-height: 76px; /*行间距*/
  margin-top: 10px;
}
.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  margin-top: 25px;
  margin-left: 40px;
}
.button-css {
  width: 90px;
  height: 35px;
  background: #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
  color: #fff;
  margin-right: 25px;
  text-align: center;
}
.search {
  width: 100%;
  height: 25px;
  display: flex;
}
.search /deep/ .el-input__inner {
  width: 314px;
  height: 24px;
}
.search /deep/ .el-input {
  width: 314px;
  height: 24px;
  line-height: 24px;
  box-sizing: border-box;
}
.search /deep/ .el-input__icon {
  line-height: 24px;
}
.search button {
  width: 85px;
  height: 24px;
  line-height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
  cursor: pointer;
  margin-left: 20px;
}
.table {
  position: absolute;
  width: 92%;
  margin-top: 10px;
  height: 520px;
}
.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
  text-align: center;
}
.operate {
  height: 51px;
}
.table /deep/ .el-dropdown {
  width: 220px;
}
.table-img-css {
  border-radius: 50%;
}
.el-dropdown-link {
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #00072b;
  width: 100%;
  display: inline-block;
}
.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.table /deep/ .el-table__cell {
  position: relative;
  text-align: center;
}
.table /deep/ .caret-wrapper {
  display: inline-block;
  position: absolute;
  top: -4px;
  right: -48px;
  width: 67px;
}
.save-button {
  width: 69px;
  height: 36px;
  background: #fff;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 10px;
  color: #51abff;
  cursor: pointer;
  margin-right: 10px;
}
.pagination {
  width: 95%;
  height: 50px;
  margin-top: 590px;
}
.pagination-main {
  float: right;
  margin-right: 10px;
  display: flex;
}
.rowsPage {
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}
.rowsPage-css {
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}
.rowsPage /deep/ .el-dropdown-link {
  /* width: 45px; */
  height: 26px;
  line-height: 26px;
}
.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/pages/administratorsViewMedicalList/index.vue